import * as actionTypes from '../constants/persist'

export const setPersist=(obj)=>async dispatch=>{
    dispatch({
        type:actionTypes.SET_PERSIST,
        payload:obj
    })
}
export const resetPersist=()=>async dispatch=>{
    dispatch({
        type:actionTypes.RESET_PERSIST,
    })
}